module.exports = __webpack_public_path__ + "static/img/11.83fcbc39.jpg";